'use strict';

var WebglRendererController = function WebglRendererController($scope, $element, $templateCache, $compile, $sce) {
  this.iframe = $element[0].querySelector('iframe').contentWindow;

  this.currentScene = null;
  this._iframeReady = false;

  this.iframeUrl = $sce.trustAsResourceUrl('/webglmap');

  this.init = function init() {
    console.log('controller map inittrd');
  };

  //bound in the directive
  this._handleSceneChange = function _handleSceneChange(newSceneDescriptor) {
    //send new scene to iframe app
    this.currentScene = newSceneDescriptor;
    if(this._iframeReady){
      this._sendCurrentScene();
    }
  };

  this._handleMessage = function _handleMessage(ev) {

    switch (ev.data) {
      case 'iframe_ready':
        this._iframeReady = true;
        this._sendCurrentScene();
      break;
    }

  };

  this._sendCurrentScene = function _sendCurrentScene() {
    if(this.currentScene){
      this.iframe.postMessage({
        type: 'new_scene',
        data: this.currentScene
      }, '*');
    }
  };

  window.addEventListener('message', this._handleMessage.bind(this));
};

module.exports = WebglRendererController;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/webglRenderer/src/WebglRendererController.js